import { Directive, ElementRef } from '@angular/core';

const greenGradientStops = [
  {
    color: '#509245',
    offset: '40%'
  },
  {
    color: '#188038',
    offset: '60%'
  }
];

@Directive({
    selector: '[appCircularProgressBarGradient]',
    standalone: false
})
export class CircularProgressBarGradientDirective {
  private readonly svgns = 'http://www.w3.org/2000/svg';
  private readonly greenGradientDefs = this.buildGreenGradientDefs();

  constructor(private spinner: ElementRef) {
    this.appendGradient();
  }

  private appendGradient(): void {
    setTimeout(() => {
      const svg = this.spinner.nativeElement.children[0];
      svg.appendChild(this.greenGradientDefs);
    });
  }

  private buildGreenGradientDefs(): any {
    const defs = document.createElementNS(this.svgns, 'defs');
    const gradient = document.createElementNS(this.svgns, 'linearGradient');
    gradient.id = 'green-gradient';

    greenGradientStops.forEach(stop => {
      const stopElement = document.createElementNS(this.svgns, 'stop');
      stopElement.setAttribute('offset', stop.offset);
      stopElement.setAttribute('stop-color', stop.color);
      gradient.appendChild(stopElement);
    });

    defs.appendChild(gradient);
    return defs;
  }
}
